
<div class="modal-alert__content">
  <div class="container">
    <!-- <div class="rte">
    <h3 class="mb-20">Thank you, your claim has been registered</h3>
  </div> -->
  <div class="mb-30">
    <h5 class="font-normal font-16 prompt" >{{question?.question_prompt}} </h5>
  </div>


  @if (claim?.has_skipped == 1) {
    <div class="note mb-15 mb-0">
      <div class="note__icon">
        <svg class="icon">
          <use xlink:href="#info"></use>
        </svg>
      </div>
      <div class="note__content">
        <h6>Some details were skipped</h6>
        <p>Skipped details prevent progress of your claim. You will be reminded to complete these.</p>
      </div>
    </div>
  }

  <div class="panel panel--reference no-shadow">
    <p class="font-semibold">
      Claim Reference No:
    </p>
    <div >
      <h5>
        {{claim?.claim_ref}}
      </h5>
    </div>
    <!--<a href="javascript:void(0)" data-copy="copy-ref-target" class="input-group-icon input-group-icon&#45;&#45;copy">
    Share this Claim Summary
    <svg class="icon">
      <use xlink:href="#link"></use>
    </svg>
  </a>-->
</div>

</div>
</div>